import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { PageContent } from '@app/components/page/PageContent';
import { PlaybackProvider } from '@app/core/playback/context/PlaybackProvider';
import { Box } from '@mui/material';
import { LoggerScreenSetup } from './components/LoggerScreenSetup';
import { LoggerStreamHeader } from './components/LoggerStreamHeader';
import { LoggerStreamPageLayout } from './components/LoggerStreamPageLayout';
import { StreamContent } from './components/StreamContent';
import { StreamDebug } from './components/StreamDebug';
import { LoggerLoader } from './components/content-loader/ContentLoader';
import { NavigationControls } from './components/controls/NavigationControls';
import { useInitializeStream } from './hooks/init/useInitializeStream';

/**
 * Main Logger Stream Screen component.
 * Keeps header and controls always visible, showing a loader only in the content area while loading.
 */
export function LoggerStreamPage() {
  // Initialize stream screen - reads params from URL and sets up
  // range, focus, cursor/selection synchronously
  // Segments loading is handled by StreamContent
  const { initialized } = useInitializeStream();

  return (
    <PlaybackProvider>
      <LoggerStreamPageLayout>
        <LoggerStreamHeader />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            minWidth: 0, // Allow flex item to shrink so waveform/stream stays within viewport (avoids horizontal scroll)
          }}
        >
          <LoggerScreenSetup />
          {initialized ? (
            <>
              <PageToolbar>
                <NavigationControls />
                <StreamDebug />
              </PageToolbar>
              <PageContent>
                <StreamContent />
              </PageContent>
            </>
          ) : (
            <LoggerLoader />
          )}
        </Box>
      </LoggerStreamPageLayout>
    </PlaybackProvider>
  );
}
